import { render, staticRenderFns } from "./BrokersFilter.vue?vue&type=template&id=167bfcce&scoped=true"
import script from "./BrokersFilter.vue?vue&type=script&lang=js"
export * from "./BrokersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167bfcce",
  null
  
)

export default component.exports